(window.SimplisticJS = function () {
  (this.formatMoney = "${{amount}}"),
    (this.beforeTrapFocus = !1),
    (this.trapFocus = function (e) {
      this.beforeTrapFocus = $(":focus");
      var n = e.namespace ? "focusin." + e.namespace : "focusin";
      e.$elementToFocus || (e.$elementToFocus = e.$container),
        e.$container.attr("tabindex", "-1"),
        e.$elementToFocus.focus(),
        $(document).on(n, function (n) {
          e.$container[0] === n.target ||
            e.$container.has(n.target).length ||
            e.$container.focus();
        });
    }),
    (this.removeTrapFocus = function (e) {
      var n = e.namespace ? "focusin." + e.namespace : "focusin";
      e.$container &&
        e.$container.length &&
        e.$container.removeAttr("tabindex"),
        this.beforeTrapFocus &&
          (this.beforeTrapFocus.focus(), (this.beforeTrapFocus = !1)),
        $(document).off(n);
    }),
    (this.handleize = function (e) {
      return e
        .toLowerCase()
        .replace(/[^\w\u00C0-\u024f]+/g, "-")
        .replace(/^-+|-+$/g, "");
    }),
    (this.reducedMotion = function () {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }),
    (this.getQueryParam = function (e, n) {
      n || (n = window.location.href), (e = e.replace(/[\[\]]/g, "\\$&"));
      var o = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(n);
      return o
        ? o[2]
          ? decodeURIComponent(o[2].replace(/\+/g, " "))
          : ""
        : null;
    }),
    (this.randomstring = function (e) {
      for (var n, o = ""; o.length < e; )
        o +=
          ((n = void 0),
          (n = Math.floor(62 * Math.random())) < 10
            ? n
            : n < 36
            ? String.fromCharCode(n + 55)
            : String.fromCharCode(n + 61));
      return o;
    }),
    (this.unique = function (e) {
      var n = [];
      return (
        $.each(e, function (e, o) {
          -1 == $.inArray(o, n) && n.push(o);
        }),
        n
      );
    }),
    (this.validateEmail = function (e) {
      return /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i.test(
        e
      );
    }),
    (this.openModal = function (e, n) {
      (modal = new tingle.modal({
        closeMethods: ["overlay", "button", "escape"],
        closeLabel: "Close",
        cssClass: [n],
      })),
        modal.setContent(e),
        modal.open();
    });
}),
  (window.Simplistic = new SimplisticJS());